export default __webpack_public_path__ + "static/media/KOD0003-min.4bff8f3b.webp";